module.exports = __webpack_public_path__ + "static/media/480.26d7df26.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-treehouse/light/480.png
// module id = 2522
// module chunks = 2